module.exports = __webpack_public_path__ + "img/icon_ser.a60e0cc.webp";